import { render } from "./HelloWorld.vue?vue&type=template&id=fcc01f68&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=fcc01f68&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-fcc01f68"

export default script